import { useEffect, useState } from "react"
import url from "../api/url"
import '../css/ListItem.css'
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

export const useAdmin = () => {

    const [empleados, setEmpleados] = useState([])
    const [cargando, setCargando] = useState(true)
    const { URL:URL_API } = url()

    const objLogueado = useEmpleadoStore( state => state.objLogueado)

    if (objLogueado.permitido !== "admin") {
        window.location.href = "/"
    }

    const traerEmpleados = () => {

        const fdata = new FormData()

        fdata.append("funcion", "traerEmpleados")

        fetch( URL_API , {
            method: 'POST',
            body: fdata
        })
        .then(res => res.json())
        .then(function (d) {

            setEmpleados(d)

        })
        .finally( e => {
            setCargando(false)
        })

    }

    //!
    function descargarExcel() {

        let data = new FormData()
        data.append("funcion", "generarExcel")

        fetch( URL_API, {
            method: 'post',
            body: data
        })
        .then((response) => {
            // const url = window.URL.createObjectURL(new Blob([response.data]));

            var blob = new Blob([s2ab(atob(response.data))], {
                type: ''
            });

            url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            // link.href = url;
            link.href = url;
            link.setAttribute('download', 'Empleados registrados.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }

    //!
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i!==s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    useEffect(() => {

        traerEmpleados()

        //eslint-disable-next-line
    }, [])



    return {
        empleados,
        cargando,
        traerEmpleados,
        descargarExcel
    }
}

